import { AutologStats, Employee, LeaderboardEntry } from "../types/types";


export const mockAutologStats: AutologStats = {
  averagePScore: 72,
  onTimeRate: 60,
  turnUpPercentage: 90,
};

export const mockEmployees: Employee[] = [
  {
    id: 1,
    name: "Nigel Tavaguta",
    status: "Arrived",
    arrivalTime: "0903hrs",
  },
  {
    id: 2,
    name: "Nashel Mashumba",
    status: "Arrived",
    arrivalTime: "0915hrs",
  },
  {
    id: 3,
    name: "Cama Mavenga",
    status: "In Transit",
    arrivalTime: "-------",
  },
  {
    id: 4,
    name: "John Doe",
    status: "In Transit",
    arrivalTime: "-------",
  },
  {
    id: 5,
    name: "Sofia Kim",
    status: "In Transit",
    arrivalTime: "-------",
  },
  {
    id: 6,
    name: "Raj Patel",
    status: "In Transit",
    arrivalTime: "-------",
  },
  {
    id: 7,
    name: "Elena Rodriguez",
    status: "In Transit",
    arrivalTime: "-------",
  },
  {
    id: 8,
    name: "Elena Rodriguez",
    status: "In Transit",
    arrivalTime: "-------",
  },
];

// export const mockLeaderboard: LeaderboardEntry[] = [
//   { id: 1, rank: 2, name: "Duncan", score: 320, avatar: "D" },
//   { id: 2, rank: 1, name: "Nigel", score: 315, avatar: "N" },
//   { id: 3, rank: 3, name: "Nashel", score: 300, avatar: "N" },
//   { id: 4, rank: 4, name: "Stanford Mondamenda", score: 290, avatar: "S" },
//   { id: 5, rank: 5, name: "Camaraderie", score: 275, avatar: "C" },
//   { id: 6, rank: 6, name: "Leon Manhimanzi", score: 260, avatar: "L" },
// ];
export const mockLeaderboard: LeaderboardEntry[] = [
  {
    id: 1,
    rank: 2,
    name: "Duncan",
    score: 320,
    avatarUrl: "https://i.pravatar.cc/150?img=12",
    avatar: "D",
  },
  {
    id: 2,
    rank: 1,
    name: "Nigel",
    score: 315,
    avatarUrl: "https://i.pravatar.cc/150?img=11",
    avatar: "N",
  },
  {
    id: 3,
    rank: 3,
    name: "Nashel",
    score: 300,
    avatarUrl: "https://i.pravatar.cc/150?img=13",
    avatar: "N",
  },
  {
    id: 4,
    rank: 4,
    name: "Stanford Mondamenda",
    score: 290,
    avatarUrl: "https://i.pravatar.cc/150?img=68",
    avatar: "S",
  },
  {
    id: 5,
    rank: 5,
    name: "Camaraderie",
    score: 275,
    avatarUrl: "https://i.pravatar.cc/150?img=10",
    avatar: "C",
  },
  {
    id: 6,
    rank: 6,
    name: "Leon Manhimanzi",
    score: 260,
    avatarUrl: "https://i.pravatar.cc/150?img=22",
    avatar: "L",
  },
];

